export const WITHDRAW_BANK_INFO_STORAGE_KEY = 'withdraw_bank_info';
export const PENALTY_REMINDER_LAST_SHOWN_KEY = 'penalty_reminder_last_shown';
